/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseEditorialCopyFragment} from '@amblique/contentful/app/contentful/fragments/editorial-copy/base-editorial-copy.fragment';
import {BaseRichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/base-rich-text-block.fragment';

export const EditorialCopyFragment = gql`
  ${BaseEditorialCopyFragment}
  ${BaseRichTextBlockFragment}

  fragment EditorialCopyFragment on EditorialCopy {
    ...BaseEditorialCopyFragment

    editorialCopy {
      ...BaseRichTextBlockFragment
    }
  }
`;
